import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
// models
import { ItemStockProps } from 'models/Quote';
import { IPrioritizedItemsTable } from './components/interface';
import { IItemDeclined } from 'models/portalModels/ItemDeclined';
import { UpdateApprovedMapAutomaticProps } from 'models/MapProduct';
import { IQuoteDetailItem } from 'models/QuoteDetailItem';
// components
import TRow from './components/TRow/TRow';
import THeader from './components/THeader';
import { Visibility } from 'components/Visibility';
import { toastify } from "components/Toastify/utils";
// Dnd components
import Loader from '../../Loader';
import { DnDCard } from '../../DragnDrop/Card';
// generics
import * as S from './styles';
import { RootState } from 'store/ducks';
import { DateOutputStrISO } from 'utils/DateOutput';
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
// services
import MapProductService from 'services/quoteMapProduct.service';

const PrioritizedItemsTable = ({
  list,
  listDnD,
  quoteId,
  cCliente,
  quoteItem,
  setListDnD,
  headerLabels,
  setOpenModal,
  itemSelected,
  modalResponse,
  setModalLoader,
  setBatchResponse,
  setListSuggestion,
  setChangeSuggestions,
  endSecondRenderMapProduct
}: IPrioritizedItemsTable) => {

  const [stock, setStock] = useState<ItemStockProps[]>();
  const [isDnD, setIsDnD] = useState(false);
  const [removeItem, setRemoveItem] = useState('');
  const [conversionFactor, setConversionFactor] = useState<any>({
    id: undefined, factor: undefined
  });
  const [notifyTooltipToClose, setNotifyTooltipToClose] = useState({
    closeAll: true, modalToBeOpened: ''
  });

  const { sequence } = useDetailsQuoteContext();

  const _mapProductService = new MapProductService();
  const user = useSelector((state: RootState) => state.user);

  useEffect(() => {
    list && setListDnD(list);
  }, [list]);

  useEffect(() => {
    if (conversionFactor?.id) {
      const { id, factor } = conversionFactor;

      const updateList = listDnD.map((item: any) => {
        if (item.id === id) {
          return {
            ...item, conversionFactor: factor
          };
        } else {
          return item;
        }
      });

      setChangeSuggestions(true);
      setListDnD(updateList);
    }

  }, [conversionFactor]);

  useEffect(() => {
    setListSuggestion(listDnD);
    if (listDnD && listDnD.length > 0 && !IsNullOrEmpty(listDnD[0])) {
      const newOrderStock = listDnD[0].itemStock?.filter((c: any) => c.stock > 0);
      setStock(newOrderStock);
    }
  }, [listDnD]);

  useEffect(() => {
    if (removeItem !== '') {
      setOpenModal(true);
    }
  }, [removeItem, setOpenModal]);

  useEffect(() => {
    if (modalResponse === 'yes') {
      deleteMapProduct(removeItem, quoteId, quoteItem?.sequenceNumber);
    } else if (modalResponse === 'no') {
      setRemoveItem('');
      setOpenModal(false);
    }
  }, [modalResponse]);

  const deleteMapProduct = async (id: string, quoteId: string, sequenceNumber: string) => {
    if (!id)
      return;

    setModalLoader(true);

    const listProduct = listDnD?.filter((item: any) => item.id !== id);
    listProduct.map(x => x.historyUsersUpdated && x.historyUsersUpdated.push({ date: DateOutputStrISO(new Date()), name: user?.username ?? "" }));

    await _mapProductService.deleteSuggestionDetails(id, quoteId, sequenceNumber, sequence)
      .then((result) => {
        if (result.status === 200) {
          toastify.success('Produto removido com sucesso!');
          setListDnD(listProduct);
          setRemoveItem('');
          setBatchResponse({ data: [{ ...quoteItem, productsSuggestion: listProduct }] });
        } else {
          toastify.error('Não foi possível remover item da lista de produtos. Por favor, tente novamente.');
        }

        setOpenModal(false);
      })
      .catch(() => {
        toastify.error('Não foi possível remover item da lista de produtos. Por favor, tente novamente.');
      });

    setModalLoader(false);
  };

  const moveCard = (result: any) => {
    const blockedMove = sequence === 1 && result.destination.index === 0;

    if (!result.destination || blockedMove) return;
    setIsDnD(true);
    const items = Array.from(listDnD);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setListDnD(items);
    setChangeSuggestions(true);
    setIsDnD(false);
    setNotifyTooltipToClose({ closeAll: true, modalToBeOpened: '' });
  };

  const hiddeHeader = document.querySelector(".header-container");
  const scrollContent = document.querySelector(".mapping-content");

  useEffect(() => {
    scrollContent?.addEventListener("scroll", () => {
      if (scrollContent.scrollTop > 100) {
        hiddeHeader?.classList.add("hidden-header");
      } else {
        hiddeHeader?.classList.remove("hidden-header");
      }
    });
  }, []);

  const approveMapProduct = async (id: string, data: UpdateApprovedMapAutomaticProps) => {
    setModalLoader(true);

    const response = await _mapProductService.UpdateApprovedMapAutomatic(data);

    if (response.status === 200) {
      let itemApproved = listDnD?.find((item: any) => item.id === id)!;
      let indexItemApproved = listDnD?.findIndex((item: any) => item.id === id)!;

      itemApproved = {
        ...itemApproved,
        isApproved: true
      };

      listDnD.splice(indexItemApproved, 1, itemApproved);

      setListDnD(listDnD);
      setBatchResponse({ data: [{ ...quoteItem, productsSuggestion: listDnD }] });
      toastify.success("De/Para aprovado");
    } else
      toastify.error("Não foi possível atualizar o De/Para");

    setModalLoader(false);
  };

  const blockedDND = (item: any) => {
    return sequence === 0 || (sequence === 1 && item.sequentialSuggestion !== "1");
  };

  const declainedItens = async (item: IQuoteDetailItem) => {
    const modalData: IItemDeclined = {
      automaticItemDeclinedType: "",
      automaticItemDeclinedMessage: "",
    };

    const listProduct = listDnD?.filter((itemFilter: any) => itemFilter.id !== item.id);
    listProduct.map(x => x.historyUsersUpdated && x.historyUsersUpdated.push({ date: DateOutputStrISO(new Date()), name: user?.username ?? "" }));
    const response = await _mapProductService.updateDeclinedItemReason(quoteId, item.sequenceNumber!, item.id!, sequence, modalData);

    if (response.status === 200) {
      setListDnD(listProduct);
      setBatchResponse({ data: [{ ...quoteItem, productsSuggestion: listProduct }] });
      toastify.success("Sugestão removida com sucesso.");
    } else {
      toastify.error("Não foi possível remover a sugestão");
    }
  };

  return (
    <S.PrioritizedItemsTable>
      <S.Table>
        <THeader headerLabels={headerLabels} />
        <Visibility visible={!listDnD}>
          <div className="body">
            <Loader size={45} />
          </div>
        </Visibility>
        <Visibility visible={!!listDnD}>
          <Visibility visible={listDnD?.length <= 1}>
            <div className="body">
              {
                listDnD?.map((item: any, i: number) => (
                  <S.Row key={item.id} stock={stock?.length === 0}>
                    <TRow
                      noDelete
                      index={i}
                      item={item}
                      quoteId={quoteId}
                      cCliente={cCliente}
                      removeItem={setRemoveItem}
                      itemSelected={itemSelected}
                      declainedItens={declainedItens}
                      approveMapProduct={approveMapProduct}
                      setConversionFactor={setConversionFactor}
                      notifyTooltipToClose={notifyTooltipToClose}
                      setNotifyTooltipToClose={setNotifyTooltipToClose}
                      endSecondRenderMapProduct={endSecondRenderMapProduct}
                    />
                  </S.Row>
                ))
              }
            </div>
          </Visibility>
          <Visibility visible={listDnD?.length > 1}>
            <DragDropContext onDragEnd={moveCard}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div className="body" {...provided.droppableProps} ref={provided.innerRef}>
                    {listDnD?.map((item: any, i: number) => (
                      <Draggable key={item.id} draggableId={item.id} index={i} isDragDisabled={!blockedDND(item)}>
                        {(provided, snapshot) => (
                          <DnDCard
                            index={i}
                            item={item}
                            key={item.id}
                            className="background-row"
                            outStock={stock?.length === 0}
                            isDragging={snapshot.isDragging}
                            endSecondRenderMapProduct={endSecondRenderMapProduct}
                          >
                            <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                              <TRow
                                index={i}
                                item={item}
                                quoteId={quoteId}
                                cCliente={cCliente}
                                removeItem={setRemoveItem}
                                itemSelected={itemSelected}
                                declainedItens={declainedItens}
                                approveMapProduct={approveMapProduct}
                                setConversionFactor={setConversionFactor}
                                notifyTooltipToClose={notifyTooltipToClose}
                                setNotifyTooltipToClose={setNotifyTooltipToClose}
                                endSecondRenderMapProduct={endSecondRenderMapProduct}
                              />
                            </div>
                          </DnDCard>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Visibility>
        </Visibility>
      </S.Table>
    </S.PrioritizedItemsTable>
  );
};

export default PrioritizedItemsTable;